'use client';
import { ThemeProvider as ThemeProvider$1 } from 'next-themes';
import { ThemeProvider as ThemeProvider$2, Global } from '@wanteddev/wds-engine';
import useThemeControl from '../hooks/use-theme-control.mjs';
import StoreProvider from './store-provider.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var ThemeProvider = ({
  children,
  enableDarkMode,
  disableTransitionOnChange = false,
  storageKey = "theme",
  disableDefaultGlobalStyle = false,
  provider
}) => {
  return /* @__PURE__ */ jsx(
    ThemeProvider$1,
    {
      themes: enableDarkMode ? ["light", "dark"] : ["light"],
      enableSystem: enableDarkMode || false,
      enableColorScheme: true,
      disableTransitionOnChange,
      forcedTheme: enableDarkMode ? void 0 : "light",
      storageKey,
      children: /* @__PURE__ */ jsx(
        PrivateThemeProvider,
        {
          disableDefaultGlobalStyle,
          provider,
          children
        }
      )
    }
  );
};
var PrivateThemeProvider = ({
  children,
  disableDefaultGlobalStyle,
  provider
}) => {
  const { theme } = useThemeControl();
  return /* @__PURE__ */ jsxs(ThemeProvider$2, { theme, provider, children: [
    /* @__PURE__ */ jsx(StoreProvider, { children }),
    /* @__PURE__ */ jsx(
      Global,
      {
        styles: disableDefaultGlobalStyle ? void 0 : (themeObj) => ({
          body: {
            backgroundColor: themeObj.palette.background.normal.normal
          }
        })
      }
    )
  ] });
};
var theme_provider_default = ThemeProvider;

export { theme_provider_default as default };
